import Row from "@Containers/components/Row";
import TravelingDotComRouteAmenityIcon from "@Route/features/amenities/components/TravelingDotComRouteAmenityIcon";
import routeIconsHashMapResolver from "@Route/features/amenities/functions/routeIconsHashMapResolver";
import GenericPopover from "@Popover/components/GenericPopover";
import React from "react";
import useIsDesktop from "@Hooks/selector/useIsDesktop";
import {useToggle} from "@Hooks/dispatch/useToggle";
import {AmenityType} from "@Route/types/travelInfo/Amenity.type";

type AmenityContainerProps = {
    amenity: AmenityType,
    displayDescription?: boolean
}

function AmenityContainer({amenity, displayDescription}: AmenityContainerProps) {
    const isDesktop = useIsDesktop();
    const {value: showDescription, onChange: toggleDescription} = useToggle(false)
    const hasIcon = routeIconsHashMapResolver(amenity?.id) !== 'noInfoAvailableOption'
    if (!hasIcon) {
        return null
    }

    return (
        <>
            <Row center key={amenity.id} style={{paddingTop: '1rem'}}>
                <button onClick={toggleDescription} type="button">
                    <TravelingDotComRouteAmenityIcon
                        tag={routeIconsHashMapResolver(amenity?.id)}
                    />
                </button>
                {isDesktop ? (
                    <GenericPopover
                        id={amenity?.id.toString()}
                        trigger={<span>{amenity.label}</span>}
                        overlay={<div>{amenity?.description}</div>}
                    />
                ) : (
                    <button onClick={toggleDescription} type="button">
                        {amenity.label}
                    </button>
                )}
            </Row>
            {!isDesktop && displayDescription && amenity?.description && showDescription && (
                <small>
                    {amenity.description}
                </small>
            )}
        </>
    );
}

export default AmenityContainer;